import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { IconButton, Toolbar, Typography } from "@mui/material";
import { styled, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { devcenterTheme } from "../_global-mui-theme";

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import MenuIcon from "@mui/icons-material/Menu";
import LaunchIcon from "@mui/icons-material/NorthEast";
import CloseIcon from "@mui/icons-material/Close";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import "../../assets/css/gnb.scss";

{
  /*
    devcenter gate-gnb.jsx를 기반으로 작성
  */
}

const HDCAppBar = styled(AppBar)(({ theme }) => ({
  minWidth: "320px",

  "&.MuiPaper-root.MuiAppBar-root": {
    color: "white",
  },

  ".MuiToolbar-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 32px",
  },

  ".MuiButtonBase-root": {
    color: "white",
  },

  "svg path": {
    fill: "white",
  },

  [theme.breakpoints.up("md")]: {
    paddingRight: "20px",
    ".MuiToolbar-root": {
      minHeight: "72px",
    },
  },

  [theme.breakpoints.down("md")]: {
    ".MuiToolbar-root": {
      minHeight: "56px",
      // padding: '0 24px',
    },
  },
}));

const HDCLogo = styled("img")(({ theme }) => ({
  cursor: "pointer",

  [theme.breakpoints.down("md")]: {
    height: "20px",
  },
}));

const HDCMenu = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const HDCDrawerWrapper = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

const HDCDrawer = styled(Box)(({ theme }) => ({
  width: "320px",
  svg: {
    fill: "white",
  },

  ".MuiList-root": {
    marginTop: "132px",
  },

  ".MuiListItem-root": {
    borderBottom: "1px solid rgba(255,255,255,0.2)",

    "&:last-child": {
      borderBottom: "none",
    },
  },

  ".MuiListItemButton-root": {
    padding: "12px 0",

    ".MuiTypography-body1": {
      color: "#fff",
      fontSize: "1.125rem",
      lineHeight: "24px",
    },
  },

  ".MuiListItemIcon-root": {
    minWidth: "40px",
  },
}));

const RUN_EXAMPLE = "run-example";
const WEBHWP_EXAMPLE = "webhwp-example";

const getMenuList = () => {
  let menuList = new Array();
  menuList.push(
    {
      link: `${process.env.REACT_APP_DEVCENTER_URL}/docsmenu/`,
      name: "docs",
      targetIsBlank: false,
    },
    {
      link: `${process.env.REACT_APP_DEVCENTER_URL}/opensources/`,
      name: "opensources",
      targetIsBlank: false,
    },
    {
      link: `${process.env.REACT_APP_DEVCENTER_URL}/tools/`,
      name: "tools",
      targetIsBlank: false,
    },
    {
      link: `${process.env.REACT_APP_DEV_FORUM_URL}`,
      name: "forum",
      targetIsBlank: true,
    }
  );
  return menuList;
};

function menuItem(t) {
  return getMenuList().map((item) => (
    <Grid item key={item.link}>
      <Button
        onClick={() =>
          window.open(item.link, item.targetIsBlank ? "_blank" : "_self")
        }
      >
        {t(`header.menu.name.${item.name}`)}
        {item.targetIsBlank && (
          <LaunchIcon fontSize="small" sx={{ ml: "4px" }} />
        )}
      </Button>
    </Grid>
  ));
}

function Gnb({ pageType }) {
  const { t } = useTranslation("translation");
  const [state, setState] = useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const drawerMenu = getMenuList()
    .filter((item) => item.name !== "tools")
    .map((item) => item);

  const list = (anchor) => (
    <HDCDrawer
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <IconButton
        sx={{ float: "right", margin: "8px 20px 0 0", color: "white" }}
        onClick={toggleDrawer("left", false)}
      >
        <CloseIcon />
      </IconButton>
      <List sx={{ m: 3 }}>
        <ListItem disablePadding key="home">
          <ListItemButton href={process.env.REACT_APP_DEVCENTER_URL}>
            <ListItemIcon>
              <HomeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="홈" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding key={drawerMenu[0].link}>
          <ListItemButton
            onClick={() => window.open(drawerMenu[0].link, "_self")}
          >
            <ListItemIcon>
              <InsertDriveFileOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="문서" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding key={drawerMenu[1].link}>
          <ListItemButton
            onClick={() => window.open(drawerMenu[1].link, "_self")}
          >
            <ListItemIcon>
              <CodeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="오픈소스" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding key={drawerMenu[2].link}>
          <ListItemButton
            onClick={() => window.open(drawerMenu[2].link, drawerMenu[2].name)}
          >
            <ListItemIcon>
              <QuestionAnswerOutlinedIcon />
            </ListItemIcon>
            <Typography sx={{ my: "4px" }}>포럼</Typography>
            <CallMadeOutlinedIcon fontSize="small" />
          </ListItemButton>
        </ListItem>
      </List>
    </HDCDrawer>
  );

  return (
    <ThemeProvider theme={devcenterTheme}>
      <HDCAppBar elevation={0} sx={{ display: "block", bgcolor: "#000" }}>
        <Toolbar>
          <HDCLogo
            src="/img/logo.svg"
            alt="Hancom Developers Center"
            onClick={() =>
              (window.location.href = process.env.REACT_APP_DEVCENTER_URL)
            }
          />
          {pageType === `${WEBHWP_EXAMPLE}` && (
            <HDCMenu
              container
              item
              sx={{
                width: "auto",
                m: "0 48px",
                ".MuiButtonBase-root": {
                  minWidth: "64px",
                  padding: "8px",
                  margin: "0 8px",
                  "&:hover": { textDecoration: "underline" },
                },
              }}
            >
              {menuItem(t)}
            </HDCMenu>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <HDCSelect /> */}

            <HDCDrawerWrapper item>
              <React.Fragment>
                {pageType === `${WEBHWP_EXAMPLE}` && (
                  <IconButton
                    onClick={toggleDrawer("left", true)}
                    sx={{
                      "&.MuiButtonBase-root": {
                        minWidth: "32px",
                        padding: "4px",
                      },
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                )}
                <Drawer
                  anchor="right"
                  open={state["left"]}
                  onClose={toggleDrawer("left", false)}
                  sx={{
                    padding: "0",
                    ".MuiDrawer-paper": { backgroundColor: "#000" },
                  }}
                  elevation={0}
                >
                  {list("left")}
                </Drawer>
              </React.Fragment>
            </HDCDrawerWrapper>
          </Box>
        </Toolbar>
      </HDCAppBar>
    </ThemeProvider>
  );
}

export default Gnb;
